import { VerifiedBadge } from '@/components/creve/VerifiedBadge';
import { FileCheck2, IdCard, ShieldCheck } from 'lucide-react';
import React from 'react';

const STEPS = [
  { icon: IdCard, text: 'Vendor submits their NIN and FUTO school ID' },
  { icon: FileCheck2, text: "Creve's team cross-checks both against records" },
  { icon: ShieldCheck, text: 'Only then does the Verified badge unlock' },
];

export const VerifiedShowcase: React.FC = () => {
  return (
    <section className='bg-secondary/40 py-20 sm:py-28'>
      <div className='container'>
        <div className='grid items-center gap-12 lg:grid-cols-2'>
          {/* Copy + steps */}
          <div>
            <span className='text-xs font-bold uppercase tracking-widest text-primary'>
              The Verified badge
            </span>
            <h2 className='font-heading mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl'>
              Trust you can see, on every vendor.
            </h2>
            <p className='mt-4 text-base leading-relaxed text-muted-foreground'>
              Before a vendor lists a single product, Creve verifies their
              real identity against their National Identification Number and
              their FUTO school ID. Pass both checks and the coral{' '}
              <span className='font-semibold text-foreground'>Verified</span>{' '}
              badge appears next to their name — permanently, on every
              listing they post.
            </p>

            <ul className='mt-8 space-y-4'>
              {STEPS.map(({ icon: Icon, text }) => (
                <li key={text} className='flex items-start gap-3'>
                  <span className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary'>
                    <Icon className='h-4 w-4 text-primary' strokeWidth={2.25} />
                  </span>
                  <p className='pt-1 text-sm font-medium text-foreground'>
                    {text}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Mock vendor card */}
          <div className='flex justify-center'>
            <div className='w-full max-w-sm rounded-2xl border border-border bg-card p-5'>
              <div className='flex items-center gap-3'>
                <div className='flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary font-heading text-base font-bold text-primary-foreground'>
                  AO
                </div>
                <div className='min-w-0'>
                  <div className='flex items-center gap-2'>
                    <p className='truncate font-heading text-base font-bold text-foreground'>
                      Amaka's Provisions
                    </p>
                    <VerifiedBadge verified />
                  </div>
                  <p className='mt-0.5 text-sm text-muted-foreground'>
                    Computer Science · 300 Level
                  </p>
                </div>
              </div>

              <div className='mt-4 aspect-[4/3] w-full overflow-hidden rounded-xl bg-gradient-to-br from-secondary to-accent/20' />

              <div className='mt-4 flex items-center justify-between'>
                <p className='text-sm font-medium text-muted-foreground'>
                  Indomie Super Pack (carton)
                </p>
                <p className='font-heading text-lg font-bold text-foreground'>
                  ₦4,500
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifiedShowcase;
